import { useQuery } from '@tanstack/react-query';
import { Axios } from '../axios';
import { handleLogout } from '../auth';
import { toast } from 'sonner';
import { backendBaseUrl } from '@/lib/constants';
import axios from 'axios';
import useHasClaim from '@/hooks/useHasClaim';
const localData = JSON.parse(localStorage.getItem('user'));
let entityType = localData?.user?.entityType;

export const useGetAllUsers = (queryParams) => {
  return useQuery({
    queryKey: ['getAllUsers', queryParams],
    queryFn: async () => {
      const result = await Axios.get(`${entityType}/users?${queryParams}`);
      return result.data;
    },
    enabled: !!queryParams,
  });
};

export const useFetchUsersByRoleId = (
  selectedRoleId,
  checkId,
  queryParams = '',
) => {
  return useQuery({
    queryKey: ['fetchUsersByRoleId', selectedRoleId, checkId, queryParams],
    queryFn: async () => {
      const result = await Axios.get(
        `${entityType}/users?roleId=${selectedRoleId}&allowedCheckId=${checkId}${queryParams && queryParams?.trim() !== '' ? `&${queryParams}` : ''}`,
      );
      return result.data;
    },
    enabled: !!(selectedRoleId && checkId),
  });
};

export const useGetCurrentUser = () => {
  return useQuery({
    queryKey: ['getCurrentUser'],
    queryFn: async () => {
      const result = await Axios.get(`${entityType}/user`);
      return result.data;
    },
  });
};

export const UpdateCurrentUser = (body) => {
  const response = Axios.put(`${entityType}/user`, body);
  return response;
};

export const UpdateBCAProfile = (body) => {
  const response = Axios.put(`${entityType}`, body);
  return response;
};

export const useGetUser = (userId) => {
  const { hasClaim } = useHasClaim();
  return useQuery({
    queryKey: ['getUser', userId],
    queryFn: async () => {
      const result = await Axios.get(`${entityType}/users/${userId}`);
      return result.data;
    },
    enabled: !!userId && hasClaim(['manage_users', 'read_users']),
  });
};

export const CreateUser = (body) => {
  const response = Axios.post(`${entityType}/users`, body);
  return response;
};

export const CreateBulkUsers = (body) => {
  const response = Axios.post(`${entityType}/users/bulk-users`, body);
  return response;
};

export const UpdateUser = (id, body) => {
  const response = Axios.put(`${entityType}/users/${id}`, body);
  return response;
};
export const DeleteUser = (id) => {
  const response = Axios.delete(`${entityType}/users/${id}`);
  return response;
};

export const useGetCurrentCandidate = (authToken) => {
  const config = {
    headers: {
      Authorization: `Bearer ${authToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return useQuery({
    queryKey: ['getCurrentCandidate'],
    queryFn: async () => {
      try {
        const result = await axios.get(`${backendBaseUrl}/candidate`, config);
        return result?.data?.data;
      } catch (error) {
        if (error?.response?.status === 401) {
          handleLogout();
        }
        toast.error(error?.message);
        return;
      }
    },
    enabled: !!authToken,
  });
};

export const UpdateBCAConfigurations = (body) => {
  const response = Axios.put(`BCA/configurations`, body);
  return response;
};

// Billing Configuration APIs
export const useGetBillingConfigurations = (companyId) => {
  return useQuery({
    queryKey: ['getBillingConfigurations', companyId],
    queryFn: async () => {
      const result = await Axios.get(
        `bca/companies/${companyId}/billing-configurations`,
      );
      return result.data;
    },
    enabled: !!companyId,
  });
};

export const saveBillingConfigurations = (companyId, body) => {
  const response = Axios.post(
    `bca/companies/${companyId}/billing-configurations`,
    body,
  );
  return response;
};
